import React, { useState, useEffect } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Title from "../general/title"
import _ from "lodash"
import { Link, useLocation } from "react-router-dom"
import FullTable from "components/FullTable"
import helpers from "helpers/helpers"
import settings from "settings"
import currentUser from "helpers/currentUser"

function EntryFloorplans(props) {
	const [filtered, setFiletered] = useState([])
	let user = currentUser()
	const location = useLocation()
	let columns = [
		{
			Header: "ID",
			accessor: "id",
		},
		{
			Header: "Builder",
			accessor: "builder",
			filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
		},
		{
			Header: "Name",
			accessor: "name",
			filterMethod: (f, r) => helpers.tableText(f, r, "name"),
		},
		{
			Header: "Sq. Ft",
			accessor: "sqft",
		},
		{
			Header: "Stories",
			accessor: "stories",
		},
		{
			Header: "Beds",
			accessor: "beds",
		},
		{
			Header: "Full Baths",
			accessor: "full_baths",
		},
		{
			Header: "Half Baths",
			accessor: "half_baths",
		},
		{
			Header: "Garage",
			accessor: "garage",
		},
		{
			Header: "Edit",
			accessor: "edit",
		},
	]

	const buildTable = (type) => {
		let data = []
		_.forEach(props.payload.public.floorplans, (v) => {
			if(!user?.builders?.includes(v.builder)) return
			let r = {}
			r.id = v.id
			r.name = v.name
			r.beds = v.beds
			r.full_baths = v.full_baths
			r.half_baths = v.half_baths
			r.garage = v.garage
			r.sqft = v.sqft
			r.stories = v.stories
			let builder = _.find(props.payload.public.builders, { id: v.builder })
			if (builder) {
				r.builder = builder.name
			}
			let type = "entry"
			if(location.pathname.includes("/arc/")) type = "arc"
			else if(location.pathname.includes("/salesManager/")) type = "salesManager"
			r.edit = (
				<Link to={`/${type}/floorplan/${v.id}`}>
					<i className="far fa-edit"></i>
				</Link>
			)
			data.push(r)
		})
		return data
	}

	if (props.payloadStatus) {
		return (
			<div className="communities">
				<Title title="Floorplan Management" showDate={false} />
				<div className="content">
					{/* <div className="admin__add">
						<Link to={"/admin/floorplans/add"}>
							<i className="fas fa-plus-circle" />
						</Link>
					</div> */}
					<FullTable
						data={buildTable()}
						columns={columns}
						name="floorplans"
						title="Floorplans"
						unset={["edit"]}
						pageSize={20}
						defaultSorted={[
							{
								id: "name",
								asc: true,
							},
						]}
					/>
				</div>
			</div>
		)
	} else {
		return ""
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(EntryFloorplans)
